export const AbrirDetalle = () => {
  document.getElementById("contenedorDetalle").style.display = "block";
  document.getElementById("detalle").style.display = "block";
  const columna1 = document.querySelector("#columna1");
  const contenedorDetalle = document.querySelector("#contenedorDetalle");

  if (columna1) {
    columna1.classList.remove("col-12");
    columna1.classList.add("col-9");
  }
  if (contenedorDetalle) {
    if (!document.getElementById("contenedorEnRuta")) return;
    if (!document.getElementById("sidebarNuevaSalida")) return;
    document.getElementById("contenedorPruebas").style.display = "none";
    document.getElementById("sidebarNuevaSalida").style.display = "none";
  }
};

export const CerrarDetalle = () => {
  if (!document.getElementById("contenedorDetalle")) return;
  document.getElementById("contenedorDetalle").style.display = "none";
  document.getElementById("sidebarNuevaSalida").style.display = "none";
  document.getElementById("contenedorPruebas").style.display = "none";
  const cerrar = document.querySelector(".icono-cerrar");
  const columna1 = document.querySelector("#columna1");

  if (cerrar) {
    columna1.classList.remove("col-9");
    columna1.classList.add("col-12");
  }
};
